export default 'https://tme.understood.org/assets/background.9f831599.glb'